import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=c73600c4&scoped=true&"
import script from "./PhotoModal.vue?vue&type=script&lang=js&"
export * from "./PhotoModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoModal.vue?vue&type=style&index=0&id=c73600c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73600c4",
  null
  
)

export default component.exports